<template>
  <div>
    <PasswordForm />
    <br />
    <TwoFactorForm />
    <br />
    <TelegramForm />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PasswordForm from './PasswordForm.vue'
import TwoFactorForm from './TwoFactorForm.vue'
import TelegramForm from './TelegramForm.vue'

export default defineComponent({
  name: 'AccountSettings',
  components: {
    PasswordForm,
    TwoFactorForm,
    TelegramForm
  }
})
</script>
